module.exports = __webpack_public_path__ + "static/media/pass_failed.7dd46936.svg";